import React, { useState } from 'react';
import { Icon, Button, TitleAndSubtitle, ProductImage, Rating, Excerpt, Metabar } from 'audamatic-ui';
import PriceBlock from '@components/base_price-block/component';
import StockCounter from '@components/stock_counter/component';
import DeliveryPromise from '@components/sec_delivery-promise/component';
import TypeSet from '@components/base_typeset/component';
import { Product } from '@utils/product';
import AddToCartButton  from '@components/ui_add-to-cart-button/component';
import Text from '@components/ui_text/component';
import Link from '@components/base_link/component';

import PropTypes from 'prop-types';
import './styles.scss';

const AnkeilerModal = (props) => {
  const { store, items, index } = props;
  const [item, setItem] = useState(index);

  const product = new Product(items[item]);

  const {
    type,
    rating,
    stockLevel,
    language,
    releaseDate,
    ean,
    sku,
    rightOfReturn,
    longDescription,
    offered,
    availability,
    fullProductAvailability,
    isExpressorder,
    name,
    price,
    personsLinks,
    url,
    isCBProduct,
    isCBBuitenlandsProduct,
  } = product;

  const renderRightOfReturn = (
    <div className="right-of-return"><TypeSet scale="0" tag="div"><Text>product.metadata.rightofreturn</Text></TypeSet>:&nbsp;
      <TypeSet scale="0" bold color="cta">
        {!!rightOfReturn ? (
          <Text>product.metadata.rightofreturn.yes</Text>
        ) : (
          <Text>product.metadata.rightofreturn.no</Text>
        )}
      </TypeSet>
    </div>
  );

  const meta = () => {
    const items = [
      language?.map((language, i) => {
        return <div className="language" key={`language-${i}`}>{language}</div>;
      }),
      <div className="ean">{ean || sku}</div>,
      !!releaseDate && <div className="release-date">{releaseDate}</div>,
      !!type && <div className="producttype">{type}</div>,
      !!rating && <Rating size="small" rating={rating}/>,
      stockLevel > 0 && !isCBProduct && !isCBBuitenlandsProduct && <StockCounter stockCount={stockLevel}/>,
      renderRightOfReturn,
    ];
    return (
      <div className="meta-data">
        <Metabar>
          {items.filter(Boolean)}
        </Metabar>
      </div>
    );
  };

  const availibilityText = isExpressorder ? (
    t('expressorder.deliveryPromise')
  ) : (
    fullProductAvailability
  );

  const navPrevious = () => {
    if (item > 0) {
      setItem(item - 1);
    }
  };

  const navNext = () => {
    if ((item + 1) < items.length) {
      setItem(item + 1);
    }
  };

  const title = <Link title={name} href={url} onClick={() => store.modal.closeModal()}>{name}</Link>;

  return (
    <div className="ankeiler-modal">
      <section className="nav-buttons">
        <Button
          variant="tertiary"
          size="small"
          disabled={item < 1}
          iconLeft={<Icon size="sm" name="NavArrowLeft"/>}
          onClick={navPrevious}
        />
        <Button
          variant="tertiary"
          size="small"
          disabled={(item + 1) >= items.length}
          iconLeft={<Icon size="sm" name="NavArrowRight"/>}
          onClick={navNext}
        />
      </section>
      <section className="image">
        <ProductImage product={product} maxHeight={135} />
        <div className="haslink">
          <TitleAndSubtitle title={title} subtitle={personsLinks}/>
        </div>
      </section>
      <section className="content">
        {meta()}

        <Excerpt
          text={longDescription}
          maxLines={3}
          label1={<Text>common.link.readmore</Text>}
          label2={<Text>common.link.readless</Text>}
        />
      </section>
      <section>
        <PriceBlock product={product} priceToPay={price.value} store={store} size="medium"/>
      </section>
      <section className="purchase">
        <AddToCartButton
          store={store}
          product={product}
          showQuantity={true}
          showOrderlineReference={true}
          showExpressOrder={true}
        />
        {!!availability && (
          <div className="delivery">
            <DeliveryPromise
              offered={offered}
              text={availibilityText}
              showIcon={false}
            />
          </div>
        )}
      </section>
    </div>
  );
};

AnkeilerModal.propTypes = {
  product: PropTypes.object,
  store: PropTypes.object,
  items: PropTypes.array,
  index: PropTypes.number,
};

export default AnkeilerModal;
